<template >
    <div class="createMannual">
      <div class="startPlane flex_r f_ai_c f_jc_b" @click="handleCreate">
        <div class="flex_r">
          <img src="../assets/Color-picker.png">
          <div class="flex_c" style="gap: 15px ;margin-top: 7px">
            <div class="fs24 fw700 " style="color:#7592F6 ">欢迎开始新的体验！</div>
            <div class="fs16 fw400 " style="color: #C5C5C5;"> 即刻点击 即开始新 建电子说明书</div>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="116" height="116" viewBox="0 0 116 116" fill="none">
          <path
              d="M82.826 61.0759L39.326 104.576L33.1742 98.4241L73.5983 58L33.1742 17.5759L39.326 11.4241L82.826 54.9241C84.5248 56.6229 84.5248 59.3771 82.826 61.0759Z"
              fill="white"/>
        </svg>
      </div>

    </div>
</template>
<script>
import creatInstructions from "./creatInstructions.vue";
  export  default  {
    name:'createMannual',
    data(){
      return {
        showCreatInstructions:false,
      }
    },
    methods:{
      handleClose(){
        this.showCreatInstructions=false
      },
      handleCreate() {
        this.$EventBus.$emit('createInstructions')
      },
    },
  }
</script>

<style scoped lang="scss">
  .createMannual{
    width: 100%;
    height: 100%;
    position: relative;



  }
  .startPlane{
    width: 780px;
    height: 167px;
    order-radius: 12px;
    background: rgba(25, 102, 218, 0.04);
    padding: 0px 30px;
    box-sizing: border-box;
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);


  }

</style>
